<div>
  <h5 class="titulo-contenedor">{{ 'PACKS.PRODUCTOS_SELECCIONADOS' | translate }}</h5>
  <div class="row contenedor-vc">

    <ng-container *ngFor="let pvc of productosSeleccionados; let last = last">
      <app-proyecto-venta-cruzada
        [productoVC]="pvc"
        [form]="formMap[pvc.configProyecto.codProductoVc]"
        [estadoDescuentos]="estadoDescuentos"
        (update)="onModificarProductoVC($event)"
        (remove)="onSeleccionarProductoVC($event, false)">
      </app-proyecto-venta-cruzada>

      <ng-container *ngIf="!last">
        <span class="vc-separador" aria-hidden="true" title="+">
          <ca-icon class="icono_sep">add</ca-icon>
        </span>
      </ng-container>
    </ng-container>

  </div>
</div>
<div *ngIf="estadoDescuentos !== 'SIN_DESCUENTOS' && productosSeleccionados.length === 1">
  <p class="mensaje-descuentos">{{ 'PACKS.DESCUENTOS.INFORMACION.CONTRATA' | translate }}</p>
</div>
<ng-container *ngIf="productosDisponibles.length > 0">
  <div class="mt-2">
    <h5 class="titulo-contenedor">{{'PACKS.PRODUCTOS_DISPONIBLES' | translate}}</h5>
    <div class="row contenedor-vc">
      <ng-container *ngFor="let pvc of productosDisponibles">
        <app-proyecto-venta-cruzada [productoVC]="pvc" [form]="formMap[pvc.configProyecto.codProductoVc]"
          [estadoDescuentos]="estadoDescuentos" (add)="onAnadirProductoVC($event)"
          (select)="onSeleccionarProductoVC($event, true)"
          (simular)="onSimularProductoVC($event)"></app-proyecto-venta-cruzada>
      </ng-container>
    </div>
  </div>
</ng-container>